//import Cookies from 'universal-cookie';
import { AuthService } from './auth.service';
import { route } from 'preact-router';

export class BaseService {

    constructor(public auth: AuthService) {

    }

    protected processResponse(response) {
        if (response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            if (response.status == 401 || response.status == 403) {
                (window as any)['location'] = "/register";
                return;
            }
            return response.text().then(r => {
                var msg = { errorMessage: r, status: response.status, statusText: response.statusText };
                console.log(msg);
                return Promise.reject(msg)
            });

        }
    }

    protected fetchFailed(error, url) {
        console.log(arguments);
        return Promise.reject({
            errorMessage: "Url: " + url + " \r\n Error message: " + (error.errorMessage || error.message)
        })
    }

    protected getOptions(method, body, json, auth) {

        var options = {
            method: method,
            headers: {
                'Accept': 'application/json, text/plain, */*'
            },
            body: undefined
        };

        if (json) {
            options.headers['Content-Type'] = 'application/json';
            options.body = body ? JSON.stringify(body) : body;
        }
        else if (body) {
            var fd = new FormData();
            for (var key in body) {
                fd.append(key, body[key]);
            }
            options.body = fd;
        }

        if (auth) {
            var token = this.auth.getToken();
            options.headers['Authorization'] = 'Bearer ' + token;
        }
        return options;

    }
}


// WEBPACK FOOTER //
// ./services/base.service.ts